/**
 * Application Configuration
 * 
 * This file contains all configurable settings for the Timer GUI application.
 * Edit these values for different deployment environments.
 */

const config = {
  // API Configuration
  api: {
    // Base URL for the backend API
    baseUrl: 'https://nocodb.apollios.com',
    
    // API Endpoints
    endpoints: {
      // NoCoDB table IDs and endpoints
      floors: {
        tableId: 'mvguhh3rzutwiyk',
        path: '/proxy/api/v2/tables/mvguhh3rzutwiyk/records',
        fields: 'id,name',
        whereClause: '(guid,eq,{GUID})'
      },
      floorSettings: {
        tableId: 'mrwkukk0exxrh6c',
        path: '/proxy/api/v2/tables/mrwkukk0exxrh6c/records',
        fields: 'floor,status,settings,version,id',
        whereClause: '(floor_id,eq,{floorId})~and(status_id,eq,1)'
      }
    }
  },
  
  // Default Settings (when no settings exist or while loading)
  defaults: {
    timerEnabled: false,
    onHours: 8,
    onMinutes: 0,
    offHours: 18,
    offMinutes: 0,
    floorOn: false
  },
  
  // UI Configuration
  ui: {
    // Maximum width of the central screen on desktop
    maxWidth: '800px',
    
    // Background colors
    colors: {
      background: '#101728',
      headerBackground: '#080b14'
    }
  }
};

export default config;
